import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'apc-pick-card',
  templateUrl: './pick-card.component.html',
  styleUrls: ['./pick-card.component.scss']
})
export class PickCardComponent {
  @Input() title: string = "";
  @Input() route: string;
  @Input() description: string;
  @Input() image: string;
  @Input() id: string;
  @Output() selectSectionEvent = new EventEmitter<string>();
  public translatedTitle: string = "";

  constructor(public translate: TranslateService) { }

  ngOnInit() {
    if(this.title.trim() != ""){
      this.translatedTitle =  this.translate.instant(this.title);
    }
  }
  select() {
    this.selectSectionEvent.emit(this.id);
  }
}
